import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import { useFetch } from 'use-http';
import Project from 'src/models/Project';
import { Url } from 'src/api';
import EasternTownshipList from './tract/components/EasternTownshipList';
import TownshipList from './tract/components/TownshipList';
import { LandSystem } from 'src/models/LandSystem';
import TractList from './tract/components/TractList';
import Button from 'src/components/controls/forms/redesign/FormButton';
import EasternParcelSearch from './EasternParcelSearch';
import SearchListData from 'src/models/SearchListData';
import { ODataOptions, ODataFilter, ODataOrderByDirection, ODataFilterOperators } from 'src/util/ODataBuilder';
import { IRouterPrivateProps } from 'src/components/router/RoutePrivate';
import { ITableConfig } from 'src/components/common/table';

// TODO: (JS) Rework Filter and action bar settings on different panels

const Tract = ( props: IRouterPrivateProps ) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, post, response } = useFetch();

    const [project, setProject] = useState<Project>(undefined);
    const [tractListId, setTractListId] = useState(undefined);
    const [doForceUpdate, setDoForceUpdate] = useState(new Object());

    const [tagFilterChanged, setTagFilterChanged] = useState(false);
    const [tagSearchData, setTagSearchData] = useState<Array<SearchListData>>([]);
    const [tractListDataOptions, setTractListDataOptions] = useState<ODataOptions>(new ODataOptions());

    useEffect(() => {
        let newDataOptions = _.cloneDeep(tractListDataOptions);
        newDataOptions?.clearFilters('KUDUTags');
        for ( let tagListIndex = 0; tagListIndex < tagSearchData.length; tagListIndex++) {
            if (tagSearchData[tagListIndex].state === true) {
                newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, tagSearchData[tagListIndex].tag.name));
            }
        }
    
        setTractListDataOptions(newDataOptions);
    }, [tagSearchData]);

    useEffect(() => {
        const tableConfig: ITableConfig = {
            rowCount: 20,
            idField: 'id',
            pageNumber: 1,
            columns: []
        };
        let newDataOptions = ODataOptions.from(tableConfig);
        newDataOptions.addOrderBy('Number', ODataOrderByDirection.Descending);
        setTractListDataOptions(newDataOptions);

        return () => {
            props.showPanel(false);
        };
    }, []);

    useEffect(() => {
        if (!!project?.landSystemId && project?.landSystemId === LandSystem.EastTexas) {
            props.showPanel(true);
        } else {
            props.showPanel(false);
        } 
    }, [project]);

    useEffect(() => {
        setTagSearchData(props?.searchFilterData);
    }, [props?.searchFilterData]);

    useEffect(() => {
        setTagFilterChanged(true);
    }, [tractListDataOptions]);

    const setTractListFilterDataOptions = (options: ODataOptions) => {
        setTractListDataOptions(options);
    };    
    
    const getTractListDataOptions = () => {
        return tractListDataOptions;
    };
    
    const resetTagFilterCallback = () => {
        setTagFilterChanged(false);
    };

    const loadInitialData = async () => {
        const data = await get(Url.project.getProject(appContext, appContext.projectNumber));

        if (response.ok) {
            setProject(data);
            let tempProject = (data as Project);
            if (tempProject.landSystemId === LandSystem.EastTexas) {
                setTractListId(1);
            }
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        if (doForceUpdate === true) {
            loadInitialData();
            setDoForceUpdate(false);
        }
    }, [doForceUpdate]);

    const reloadTractList = () => {
        setDoForceUpdate(new Object());
    };

    const createEastTexasTract = async () => {
        const data = await post(`${Url.project.getProject(appContext, appContext.projectNumber)}/tracts/create-east-texas-tract/`);

        if (response.ok) {
            console.log('create-east-texas', data);
            // redirect
        }
    };

    const searchPanel = () => {
        if (!project) {
            return <div>Loading...</div>;
        }

        switch (project.landSystemId) {
            case LandSystem.Eastern:
                return <EasternTownshipList setTractListId={setTractListId} />;
                break;
            case LandSystem.Jeffersonian:
            case LandSystem.WestTexas:
                return  <TownshipList
                            setTractListId={setTractListId}
                            refreshTags={props.refreshTags}
                            filterTownships={props?.filterTownships}
                            searchFilterData={tagSearchData}
                            landSystem={project.landSystemId}
                />;
                break;
            default:
                return <div>Unsupported Land System</div>;
                break;
        }
    };

    const easternSearchPanel = () => {
        if (!project) {
            return <div>Loading...</div>;
        }

        if (project.landSystemId === LandSystem.Eastern) {
            return (
                <div className="tracts-page-with-filter" style={{ padding: '1rem' }}>
                    <EasternParcelSearch />
                </div>
            );
        }
        return <></>;
    };

    const tractListPanel = () => {
        if (!project) {
            return <div>Loading...</div>;
        }

        if (!tractListId && project.landSystemId !== LandSystem.EastTexas) {
            const type =
                project.landSystemId === LandSystem.Eastern
                    ? 'map'
                    : project.landSystemId === LandSystem.Jeffersonian || project.landSystemId === LandSystem.WestTexas
                    ? 'section'
                    : '[na]';
            return (
                <div
                    style={{
                        padding: '2rem',
                        border: '2px red solid',
                        margin: '1rem 1rem',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: '1.1em',
                    }}
                >
                    No {`${type.charAt(0).toUpperCase()}${type.slice(1)}`} Selected.
                </div>
            );
        } else if (!tractListId && project.landSystemId === LandSystem.EastTexas) {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Tracts</div>
                    <div>
                        <Button size="small" intent="primary" text="Create Tract" onClick={createEastTexasTract} />
                    </div>
                </div>
            );
        }

        if (tractListId && doForceUpdate) {
            return <TractList
                resetTagFilterCallback={resetTagFilterCallback}
                refreshProjectTagsCallback={props.refreshTags}
                tagFilterUpdated={tagFilterChanged}
                getDataOptions={getTractListDataOptions}
                setDataOptions={setTractListFilterDataOptions}
                landSystem={project?.landSystemId}
                tractType={project?.tractTypeName}
                sectionNumber={tractListId}
                searchFilterData={tagSearchData}
                filterTracts={props.filterTracts}
                reloadCallback={reloadTractList}
            />;
        }

        return undefined;
    };

    return (
        <>
            {easternSearchPanel()}
            <div className={project?.landSystemId !== LandSystem.Jeffersonian ? 'tracts-page-with-filter' : ''} style={{ display: 'flex', clear: 'both'}}>
                {project?.landSystemId !== LandSystem.EastTexas && <div style={{ width: '40%' }}>{searchPanel()}</div>}
                <div style={project?.landSystemId === LandSystem.EastTexas ? { width: '100%' } : { width: '60%' }}>{tractListPanel()}</div>
            </div>

        </>
    );
};

export default Tract;



// WEBPACK FOOTER //
// ./src/components/project/sections/Tract.redesign.tsx